import { render, staticRenderFns } from "./data18.vue?vue&type=template&id=404d4d60&scoped=true"
import script from "./data18.vue?vue&type=script&lang=js"
export * from "./data18.vue?vue&type=script&lang=js"
import style1 from "./data18.vue?vue&type=style&index=1&id=404d4d60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404d4d60",
  null
  
)

export default component.exports